export default __webpack_public_path__ + "static/media/wotfard-bold-webfont.5712af5b.woff2";